<template>
  <div class="flex flex-col w-full">
    <ExpiredPositionCard
      v-if="calcSettlementDifferenceDays(position.physicalSettlementDate) > 0"
      :instrument-name="position.instrumentName"
    />

    <SymbolInfo v-else :isin="position.isin" />

    <PositionInfo :position="position" />
  </div>
</template>

<script setup lang="ts">
import { PositionHistoryItemWithPrices } from '@core/option';
import { useGetServerClock } from '@core/order';
import { getTimeDifference } from '@libs/utils';

import SymbolInfo from './SymbolInfo.vue';
import PositionInfo from './PositionInfo.vue';
import ExpiredPositionCard from '../PositionsHistory/ExpiredPositionCard.vue';

type TPositionInfoDialogProps = {
  position: PositionHistoryItemWithPrices;
};

defineProps<TPositionInfoDialogProps>();

const { time } = useGetServerClock();

const calcSettlementDifferenceDays = (date: string) =>
  getTimeDifference({
    startTime: new Date(date as string).getTime(),
    endTime: new Date(time.value).getTime(),
  }).differenceInDays;
</script>
